// components/CompanyName.jsx
import React from 'react'

export default function CompanyName() {
    return (
        <div className="company-name">
            Quantum Cat
        </div>
    )
}
